export default __webpack_public_path__ + "static/media/intro-cat-yellow.e349e6dd.png";